import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

// Chrome/Edge-only browser API for a custom "add to home screen" prompt - not in the DOM lib types.
// https://developer.mozilla.org/en-US/docs/Web/API/BeforeInstallPromptEvent
interface BeforeInstallPromptEvent extends Event {
	prompt(): Promise<void>;
	userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

@Injectable()
export class InstallService {
	private deferredPrompt: BeforeInstallPromptEvent | null = null;

	constructor(private readonly toastController: ToastController) {}

	public init(): void {
		window.addEventListener('beforeinstallprompt', (e: Event) => {
			e.preventDefault();
			this.deferredPrompt = e as BeforeInstallPromptEvent;
			this.tryShowInstallToast();
		});
	}

	private tryShowInstallToast(): void {
		const lastShownDate = localStorage.getItem('installPromptDate');
		const today = new Date().toISOString().split('T')[0];

		if (lastShownDate !== today) {
			this.showInstallToast();
			localStorage.setItem('installPromptDate', today);
		}
	}

	private async showInstallToast(): Promise<void> {
		const toast = await this.toastController.create({
			message: 'Wil je Pro Pool installeren voor snelle toegang?',
			duration: 10000,
			buttons: [
				{
					side: 'end',
					text: 'Installeren',
					handler: () => {
						this.deferredPrompt?.prompt();
						this.deferredPrompt?.userChoice.then(() => {
							this.deferredPrompt = null;
						});
					}
				},
				{
					side: 'end',
					text: 'Sluiten',
					role: 'cancel'
				}
			]
		});
		await toast.present();
	}
}
